<template>
    <div>
        <div class="list-item" v-for="(item, index) in data" :key="item.qid">
            <div :name="`name${index}`" v-if="item.isShow && item.questionsTypeId != '26'" class="question list">
                <div class="top">
                    <!-- 单选 多选 判断 -->
                    <div class="ques-body" v-if="item.questionsTypeId == '8' || item.questionsTypeId == '12' || item.questionsTypeId == '10'">
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span><span class="score" v-if="item.score">（ {{item.score}}分 ）</span>
                        </p>
                        <el-radio-group v-if="item.questionsTypeId == '8' || item.questionsTypeId == '12'" v-model="item.userAnswer" class="option-box">
                            <el-radio 
                                disabled
                                class="option"
                                v-for="info in item.optionList" 
                                :key="info.oid" 
                                :label="info.oid"
                            >
                                <p v-html="info.labelName"></p>
                                <div 
                                    v-if="info.haveInput"
                                    class="other-input">
                                    <el-input
                                        disabled
                                        size="mini"
                                        v-model="info.inputValue"
                                        >
                                    </el-input>
                                </div>
                            </el-radio>
                        </el-radio-group>
                        <el-checkbox-group v-else-if="item.questionsTypeId == '10'" v-model="item.userAnswer" class="option-box">
                            <el-checkbox 
                                disabled
                                class="option" 
                                v-for="info in item.optionList" 
                                :key="info.oid" 
                                :label="info.oid"
                            ><p v-html="info.labelName"></p>
                            <div 
                                v-if="info.haveInput"
                                class="other-input">
                                <el-input
                                    disabled
                                    size="mini"
                                    v-model="info.inputValue"
                                    >
                                </el-input>
                            </div>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <!-- 单项填空类-->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '2' || 
                        item.questionsTypeId == '3' || 
                        item.questionsTypeId == '4' || 
                        item.questionsTypeId == '5'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span>
                        </p>
                        <p class="user-answer">
                            {{item.userAnswer}}
                        </p>
                    </div>
                    <!-- 多项填空 -->
                    <div class="ques-body" v-else-if="item.questionsTypeId == '35'">
                        <p class="title">
                            Q{{item.quesIndex + 1}}.<span v-html="item.questionsName"></span>
                        </p>
                        <div class="optionList" v-for="val in item.optionList" :key="val.oid">
                            <p class="title" v-html="val.labelName"></p>
                            <p class="user-answer-item">
                                {{val.userAnswer}}
                            </p>
                        </div>
                    </div>
                    <!-- 横向填空 -->
                    <div class="ques-body" v-else-if="item.questionsTypeId == '34'">
                        <p class="title">
                            {{item.quesIndex + 1}}.<span v-html="item.questionsName"></span>
                        </p>
                        <template v-for="(val, index) in item.questionOption">
                            <span class="ques_content" v-if="typeof val == 'string'" v-html="val" :key="index"></span>
                            <div  v-else class="input_box ques_content" :key="index" > 
                                <input 
                                    disabled                                    
                                    :class="{'input__horizontal__err': item.optionList[val.index].validate}"
                                    v-model="item.optionList[val.index].userAnswer" 
                                    type="text" 
                                    :style="`display: inline-block;width:${val.width}px;border: none;border-bottom: 1px solid;outline: none;text-align: center;`">
                            </div>
                        </template>
                    </div>
                    <!-- 上传文件 -->
                    <div class="ques-body" v-else-if="item.questionsTypeId == 33">
                        <p class="title">
                            {{item.quesIndex + 1}}.<span v-html="item.questionsName"></span>
                        </p>
                        <p v-if="item.userAnswer.length == 0" class="fileList-null">无文件</p>
                        <template v-else>
                            <el-button 
                                @click="exportFile(info)"
                                class="fileList-box"
                                v-for="(info, index) in item.userAnswer" 
                                :key="index" 
                                type="text"
                            >{{info.split('/')[info.split('/').length - 1]}}</el-button>
                        </template>
                    </div>
                    <!--下拉框 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '9'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span>
                        </p>
                        <el-select v-model="item.userAnswer" disabled placeholder="请选择">
                            <el-option
                            v-for="info in item.optionList"
                            :key="info.oid"
                            :label="$functions.filterHtmlTag(info.labelName)"
                            :value="info.oid">
                            </el-option>
                        </el-select>
                    </div>
                    <!--图片选择 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '6'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span>
                        </p>
                        <div class="image-option-box"> 
                            <div 
                                class="questionImage_box" 
                                v-for="childItem in item.optionList"
                                :key="childItem.oid"
                            >
                                <img :src="childItem.optionImgUrl" alt="图片" />
                                <el-radio 
                                    disabled
                                    class="imgLabel"
                                    v-model="item.userAnswer" :label="childItem.oid"
                                    v-if="item.cutType == 7"
                                >
                                    <p v-html="childItem.labelName"></p>
                                </el-radio>
                                <el-checkbox 
                                    disabled
                                    class="imgLabel"
                                    v-model="item.userAnswer"
                                    :label="childItem.oid"
                                    v-if="item.cutType == 8"
                                >
                                    <p v-html="childItem.labelName"></p>
                                </el-checkbox>
                            </div>
                        </div>
                    </div>
                    <!--星级评分 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '11'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span><span class="score" v-if="item.score">（ {{item.score}}分 ）</span>
                        </p>
                        <ul class="StarsWrap">
                            <li class="StarsWrap-item" v-for="(i,index) in  (item.highestScore - item.lowestScore + 1)" :key="index">
                                <img 
                                    :src="parseInt(item.userAnswer) >= index + item.lowestScore? scoreImgUrlYes : scoreImgUrlNo"
                                    alt="" />
                            </li>
                        </ul>
                        <div class="tips">
                            <span
                                v-if="item.leftPromptText!=''">{{ item.leftPromptText }}</span>
                            <span
                                v-if="item.centerPromptText!=''">{{item.centerPromptText}}</span>
                            <span
                                v-if="item.rightPromptText!=''">{{item.rightPromptText}}</span>
                        </div>
                    </div>
                    <!--日期选择 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '13'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span>
                        </p>
                        <el-date-picker
                            disabled
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy 年 MM 月 dd 日"
                            v-model="item.userAnswer"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </div>
                    <!-- 地理位置 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '15'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span>
                        </p>
                        <p style="margin-bottom: 10px" v-if="item.address">当前位置：{{item.address}}</p>
                        <el-amap :vid="'amapDemo' + item.qid" :center="center" :zoom="zoom" class="amap-demo">
                            <el-amap-marker 
                                :position="marker.position" 
                                :visible="marker.visible" 
                                :draggable="marker.draggable">
                            </el-amap-marker>
                        </el-amap>
                    </div>
                    
                    <!-- 城市选择 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '16'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span>
                        </p>
                        <p class="user-answer">
                            {{item.userAnswer}}
                        </p>
                    </div>
                    
                    <!-- 时间选择 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '17'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span>
                        </p>
                        <el-time-picker
                            disabled
                            format="HH:mm"
                            value-format="HH:mm"
                            v-model="item.userAnswer"
                            placeholder="选择时间">
                        </el-time-picker>
                    </div>

                    <!-- 矩阵题 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '19'|| 
                        item.questionsTypeId == '20' ||
                        item.questionsTypeId == '21' ||
                        item.questionsTypeId == '22' ||
                        item.questionsTypeId == '39'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span>
                        </p>
                        <div style="margin-top:10px; overflow-x:scroll;">
                            <table>
                                <tr>
                                    <td class="td_width"></td>
                                    <td class="td_width"
                                        v-for="(option,index2) in item.questionsSonList[0].optionList"
                                        :key="index2">
                                        <div style="width: 150px;" v-html="option.labelName"></div>
                                    </td>
                                </tr>
                                <tr v-for="(item2,index) in item.questionsSonList" :key="item2.SonId+index">
                                    <td class="td_width">
                                        <div style="width: 150px;" v-html="item2.questionsName"></div>
                                    </td>
                                    <td class="td_width matrix"
                                        v-for="(option,index3) in item2.optionList"
                                        :key="index+'-'+index3">
                                        <template v-if="item.questionsTypeId == '19' || item.questionsTypeId == '20'">
                                            <el-radio v-if="item.questionsTypeId == '19'" disabled v-model="item2.isSelected" :label="option.oid">{{''}}</el-radio>
                                            <el-checkbox
                                                v-else-if="item.questionsTypeId == '20'"
                                                disabled
                                                type="checkbox"
                                                :id="option.oid"
                                                v-model="option.isSelected"
                                                :label="option.oid"
                                                :name="item2.SonId"
                                            >{{''}}</el-checkbox>
                                            <input type="text" 
                                                disabled
                                                v-model="option.inputValue"
                                                v-if="option.haveInput"
                                                style="border: 1px solid #ccc;width: 60px;">
                                        </template>
                                        <template v-else-if="item.questionsTypeId == '21'">
                                            <ul class="ul_rate" :option="option.oid">
                                                <li v-for="(n,rateIndex) in item.highestScore"
                                                    :key="option.oid+'-'+rateIndex">
                                                    <img v-if="rateIndex < option.ratingScore" :src="xinga"
                                                        alt="" />
                                                    <img v-if="rateIndex >= option.ratingScore" :src="xingb"
                                                        alt="" />
                                                </li>
                                            </ul>
                                        </template>
                                        <template v-else-if="item.questionsTypeId == '22'">
                                            <input type="text" 
                                                disabled
                                                v-model="option.userAnswer"
                                                class="Rectinput" 
                                            />
                                        </template>
                                        <template v-else-if="item.questionsTypeId == '39'">
                                            <el-radio 
                                                disabled
                                                v-if="option.type == '26'"
                                                type="radio"
                                                :label="option.userAnswer"
                                                :value="1"
                                            ></el-radio>
                                            <el-select
                                                disabled
                                                :popper-append-to-body="false"
                                                size="small"
                                                placeholder="请选择"
                                                v-else-if="option.type == '10'"
                                                :class="{ input__err: option.validate }"
                                                class="Rectselect"
                                                v-model="option.userAnswer"
                                            >
                                                <el-option v-for="info in option.options" :key="info.value" :label="info.label" :value="info.label">
                                                    <span v-html="info.label"></span>
                                                </el-option>
                                            </el-select>
                                            <div v-else-if="option.type == '12'">
                                                <p v-if="option.userAnswer.length == 0" class="fileList-null">无文件</p>
                                                <template v-else>
                                                    <el-button 
                                                        @click="exportFile(info)"
                                                        class="fileList-box"
                                                        v-for="(info, index) in option.userAnswer" 
                                                        :key="index" 
                                                        type="text"
                                                    >{{info.split('/')[info.split('/').length - 1]}}</el-button>
                                                </template>
                                            </div>
                                            <el-input
                                                disabled
                                                type="textarea"
                                                v-else-if="option.type == '1'"
                                                :class="{ input__err: option.validate }"
                                                v-model="option.userAnswer"
                                                class="Rectinput"
                                            ></el-input>
                                            <input
                                                disabled
                                                v-else
                                                type="text"
                                                :class="{ input__err: option.validate }"
                                                v-model="option.userAnswer"
                                                class="Rectinput"
                                            />
                                        </template>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                     <!-- 段落标题 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '25'"
                    >
                        <p class="title">
                            <span v-html="item.questionsName"></span>
                        </p>
                    </div>
					<!-- 级联题 -->
					<div
					    class="ques-body" 
					    v-else-if="item.questionsTypeId == '36'"
					>
					    <p class="title">
					        Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span>
					    </p>
						  <el-cascader
						  style="min-width: 300px;"
						  disabled
						   v-model="item.optionValue"
						    :options="item.optionList"
							></el-cascader>
					</div>
                    
                    <!-- 比重题 -->
                    <div class="ques-body" v-else-if="item.questionsTypeId == '37'">
                        <p class="title">
                            Q{{item.quesIndex + 1}}.<span v-html="item.questionsName"></span>
                        </p>
                        <div class="optionList" v-for="val in item.optionList" :key="val.oid">
                            <p class="title" v-html="val.labelName"></p>
                            <div class="user-answer-item">
                                <div class="el-slider-box">
                                    <el-slider 
                                        disabled
                                        v-model="val.userAnswer"
                                        :show-tooltip="false"
                                    ></el-slider>
                                    <span class="num">{{val.userAnswer}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--量表题 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '38'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span><span class="score" v-if="item.score">（ {{item.score}}分 ）</span>
                        </p>
                        <ScaleType :data="item"></ScaleType>
                    </div>
                    
                    <!--排序题 -->
                    <div 
                        class="ques-body" 
                        v-else-if="item.questionsTypeId == '14'"
                    >
                        <p class="title">
                            Q{{item.quesIndex + 1}}. <span v-html="item.questionsName"></span>
                        </p>
                        <SortType :data="item"></SortType>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="kong" v-if="data.length == 0">
            <img src="../assets/empty.png" alt="" />
            <p>暂无答卷</p>
        </div>
    </div>
</template>

<script>
import ScaleType from './QuesresultsPreview/scaleType.vue'
import SortType from './QuesresultsPreview/sortType.vue'
export default {
    name: 'QuesresultsPreview',
    components: {
        ScaleType,
        SortType
    },
    props: {
        data: {
            type: Array, 
            default() {
                return []
            }
        },
    },
    data() {
        return {
            scoreImgUrlNo: require('@/assets/default-imgs/stars_2.png'),
            scoreImgUrlYes: require('@/assets/default-imgs/stars_1.png'),
            zoom: 13,
            center: [116.486635, 40.009326],
            marker: {
                position: [116.486635, 40.009326]
            },
            xinga: require('@/assets/default-imgs/stars_1.png'), //亮星星
            xingb: require('@/assets/default-imgs/stars_2.png'), //暗星星
            address: {
                province: [],
                city: [],
                district: []
            },
        }
    },
    watch: {
        'data': {
            handler(newV, oldV) {
                // console.log('监听')
                newV.forEach(info =>{
                    // 引用
                    info.questionsName = this.setAppointQues(info.questionsName)
                    // 选项关联 试题是否显示
                    this.displayLogic(info)
                    
                    if (info.questionsTypeId == 34) {
                        let questionOption = [],
                        str = info.quesOptionTitle,
                        arr = str.match(/_[_]+_/g)
                        
                        for(let i in arr){
                            let obj = JSON.stringify({width:arr[i].length * 10,})
                            str = str.replace(arr[i],`^${obj}^`)
                        }
                        let arrData = str.split('^')
                        for(let i in arrData){
                            if(arrData[i]){
                                questionOption.push(this.$functions.isJSON(arrData[i]) ? JSON.parse(arrData[i]) : arrData[i])
                            }
                        }
                        let index = 0
                        questionOption = questionOption.map((info) =>{
                            if((typeof info) != 'string'){
                                info.index = index
                                index++
                            } else {
                                info = this.$functions.HTMLClosedOrNot(info)
                            }
                            return info
                        })
                        this.$set(info, 'questionOption', questionOption)
                    } else if (info.questionsTypeId == 15) {
                        if(!info.userAnswer) return
                        this.$set(info, 'address', info.userAnswer.split(':')[1])
                        let longitude = info.userAnswer.split(':')[0].split(',')[1]
                        let latitude = info.userAnswer.split(':')[0].split(',')[0]
                        this.center = [longitude, latitude]
                        this.marker.position = [longitude, latitude]
                    } else if (info.questionsTypeId == 16) {
                        if(!info.userAnswer) return
                        this.$set(info, 'userAnswerArr', info.userAnswer.split(','))
                        this.$set(info, 'answerArr', [])
                        this.getProvince(info)
                    }
                    //  else if (info.questionsTypeId == 14) {
                    //     if(!info.userAnswer) return
                    //     this.$set(info, 'userAnswerArr', info.userAnswer.split(','))
                    //     let sortArray = JSON.parse(JSON.stringify(info.optionList))
                    //     if (!info.sortArray) {
                    //         this.$set(info, 'sortArray', sortArray)
                    //         info.sortArray.forEach((info) =>{
                    //             this.$set(info, 'optionIndex', 0)
                    //             info.userAnswerArr.forEach((item, index)=>{
                    //                 if (item == info.oid) {
                    //                     info.optionIndex = index + 1
                    //                 }
                    //             })
                    //         })
                    //     }
                    // }
                })
            },
            immediate: true
        }
    },
    created() {  
        this.data.forEach((info) => {
            if (info.questionsTypeId == '20') {
                console.log('矩阵多选题 :>> ', info);
            }
        })
    },
    mounted() {
    },
    methods: {
        getProvince(question) {
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.queryProvince}`,
                method: "POST",
                cb(res) {
                    // console.log(res)
                    if (res.code == 0) {
                        that.address.province = res.resultBody.datas
                        question.answerArr = [...question.userAnswerArr]
                        question.userAnswerArr.forEach((info, index) => {
                            question.answerArr[index] = info
                            if (index == 0) {
                                that.seleCity(info, 0, question)
                                that.answerArrBlur(question, index)
                            } else if (index == 1) {
                                that.seleCity(info, 1, question)
                            } else if (index == 2) {
                                that.seleCity(info, 2, question)
                            }
                        })
                    }
                },
            };

            params.isnologin = true
            this.$util.request(params);
        },
        
        seleCity(e, index, question) {
            if (index == 0 && this.address.city[e]) {
                //存在省下面的市
                return;
            }
            if (index == 1 && this.address.district[e]) {
                //存在市下面的区
                return;
            }
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.queryLinkage}`,
                method: "POST",
                data: {
                    id: e
                },
                cb(res) {
                    // console.log(res)
                    if (res.code == 0) {
                        if (index == 0) {
                            that.address.city = res.resultBody.datas
                            that.answerArrBlur(question, 1)
                        } else if (index == 1) {
                            that.address.district = res.resultBody.datas
                            that.answerArrBlur(question, 2)
                        }
                    }
                },
            };
            params.isnologin = true
            this.$util.request(params);
        },
        answerArrBlur(question, index) {
            let cityList = []
            if (index == 0) {
                cityList = this.address.province
            } else if (index == 1) {
                cityList = this.address.city
            } else if (index == 2) {
                cityList = this.address.district
            }
            cityList.forEach((info) => {
                if (question.userAnswerArr[index] == info.id) {
                    question.answerArr[index] = info.name
                } 
            })
            question.userAnswer = question.answerArr.join(',')
        },
        setAppointQues(name) {
            let Reg = /(\[)Q[1-9]\d*(\])/g
            let Arr = name.match(Reg)
            // console.log(Arr)
            if (Arr) {
                Arr.forEach(info => {
                    let num = info.replace(/[^0-9]/ig, '')
                    let html = `<span class="ques${num}"></span>`
                    name = name.replace(info, html)
                    // console.log(name)
                })
            }
            return name
        },
        displayLogic(data){
            if (data != undefined) {
                if(data.associated) {
                    this.data.forEach((el) => {
                        if (data.associated.indexOf(el.qid) !== -1) {
                            data.optionList.forEach((info) => {
                                if (data.userAnswerArr && data.userAnswerArr.indexOf(info.oid) !== -1){
                                    el.optionList.push(info)
                                }
                                if (data.userAnswer && data.userAnswer == info.oid) {
                                    el.optionList.push(info)
                                }
                            })
                        }
                    })
                }  
            }
            this.setQuestonName(data)
        },
        setQuestonName(data) {
            let quesTypeArr = ['6','8','9','10','12','2','3','4','5']
            this.data.forEach((info)=> {
                let Reg = /\<span class=\"ques[0-9]\">(.*?)<\/span>/g
                let spanArr = info.questionsName.match(Reg)
                if (spanArr) {
                    spanArr.forEach(el => {
                        if (data && el.match(/ques(\S*)"/)[1] == data.quesIndex + 1) {
                            if (quesTypeArr.indexOf(data.questionsTypeId) !== -1) {
                                if (data.userAnswer) {
                                    // 分组
                                    if (data.groupingOptionList.length > 0) {
                                        // console.log(data.groupingOptionList)
                                        data.groupingOptionList.forEach((group) => {
                                            group.optionList.forEach(option => {
                                                if (option.oid == data.userAnswer) {
                                                    info.questionsName = 
                                                        info.questionsName.replace(el,
                                                        `<span class="ques${data.quesIndex + 1}">${option.labelName}</span>`
                                                    )
                                                }
                                            })
                                        })

                                    }
                                    if (data.optionList.length > 0) {
                                        data.optionList.forEach((val) =>{
                                            if (val.oid == data.userAnswer) {
                                                info.questionsName = 
                                                    info.questionsName.replace(el,
                                                    `<span class="ques${data.quesIndex + 1}">${val.labelName}</span>`
                                                )
                                            }
                                        })
                                    } else {
                                        info.questionsName = 
                                            info.questionsName.replace(
                                                el,
                                                `<span class="ques${data.quesIndex + 1}">${data.userAnswer}</span>`
                                            )
                                    }
                                } else if (data.userAnswer && data.userAnswer.length > 0) {

                                    let str = ''
                                    // 分组
                                    data.groupingOptionList.forEach((group) => {
                                        group.optionList.forEach(val => {
                                            data.userAnswer.forEach((el) => {
                                                if (val.oid == el) {
                                                    str = str + val.labelName
                                                }
                                            })
                                        })
                                    })
                                    data.optionList.forEach((val) =>{
                                        data.userAnswer.forEach((el) => {
                                            if (val.oid == el) {
                                                str = str + val.labelName
                                            }
                                        })
                                    })
                                    info.questionsName = 
                                        info.questionsName.replace(
                                            el,
                                            `<span class="ques${data.quesIndex + 1}">${str}</span>`
                                        )
                                }
                            }
                        }
                    })
                }
                
            })
         
        },
        getOption(list, oid) {
            for(let i = 0;i < list.length;i++) {
                if (list[i].oid == oid) {
                    return list[i]
                }
            }
        },
        userGetScoreInput(item) {
            if (!item.userGetScoreValue) item.userGetScoreValue = 0
            if (parseFloat(item.userGetScoreValue) > 0) {
                item.isCorrect = 1
            }
        },
        exportFile(key) {
            let a = document.createElement('a')
            a.href = key
            a.download = key.split(':')[1] // 名字可自定义
            // console.log(a.download)
            a.click()
        }
    }
}
</script>

<style lang="scss" scoped>

.kong {
  width: 100%;
  background: #fff;
  margin: 0 auto;
text-align: center;
}
.kong img {
  width: 250px;
  height: 233px;
  margin-top: 100px;
  margin-left: 0;
}
.kong p {
  font-size: 20px;
  text-align: center;
  color: #999999;
  font-family: MicrosoftYahei;
  margin-top: 50px;
}
.submit{
    padding-top: 20px;
    text-align: center;
}
.list{
    // margin-top: 30px;
    position: relative;
    background-color: #fcfcfc;
    padding: 30px 39px;
    .label{
        position: absolute;
        left: 0;
        top: 12px;
        background-color: #169bd5;
        font-size: 13px;
        width: 27px;
        padding: 2px 5px;
        color: #fff;
    }
}
.list-item+.list-item{
    .list{
        padding-top: 10px ;
    }
}
.user-info{
    margin-left: 30px;
    line-height: 40px;
    .user-info-text{
        display: inline-block;
        margin-left: 20px;
        font-size: 15px;
    }
}
.question{
    .top{
        display: flex;
        justify-content: space-between;
        .ques-body{
            width: 100%;
            .fileList-null{
                font-size: 14px;
                color: #999;
            }
            .fileList-box{
                display: block;
                margin-left: 0;
            }
            .img-box{
                line-height: 190px;
                text-align: center;
                background: #f7f8fa;
                font-size: 14px;
                color: #aaa;
                width: 438px;
                height: 190px;    
                border: 1px solid rgba(0, 0, 0, 0.1);
            }
            .optionList+.optionList{
                margin-top: 10px;
            }
            .optionList{
                margin-left: 10px;
                .title{
                    display: flex;
                    align-items: center;
                    font-size: 15px;
                }
                .user-answer-item{
                    background-color: #f5f7f8;
                    font-size: 14px;
                    color: #A2A0A0;
                    padding: 10px;
                    box-sizing: border-box;
                }
            }
            .ques_content{
                font-size: 14px;
                line-height: 30px;

            }
            .input_box{
                display: inline-block;
            }
            .image-option-box{
                display: flex;
                flex-wrap: wrap;
            }
            .questionImage_box {
                width: 145px;
                border: 1px solid #ccc;
                margin: 20px 2% 0 2%;
                padding-bottom: 10px;
                border-radius: 4px;
                box-sizing: border-box; 
            }
            .questionImage_box img {
                width: 100%;
                height: 146px;
                display: block;
            }
            
            .imgLabel{
                padding: 0 10px;
                margin-top:20px;    
                display: flex;
            }
            .score{
                color: #999;
            }
        }
        .title{
            display: flex;
            align-items: start;
            margin-bottom: 10px;
            word-break: break-all;
            /deep/p:last-child{
                display: inline-block;
            }
        }
        .option-box{
            display: flex;
            flex-wrap: wrap;
            .option{
                display: flex;
                align-items: top;
                line-height: 30px;
                font-size: 14px;
                width: 100%;
                word-break: break-all;

                .option-index{
                    display: inline-block;
                    width: 25px;
                    height: 25px;
                    line-height: 25px;
                    text-align: center;
                    border-radius: 50%;
                    margin-right: 10px;
                    margin-top: 3px;
                }
                .option-action{
                    background-color:rgb(234, 240, 243);
                }
                .option-title{
                    display: inline-block;
                }
            }
        }
        .user-answer{
            background-color: #f5f7f8;
            font-size: 14px;
            color: #A2A0A0;
            padding: 10px;
            box-sizing: border-box;
        }
        /deep/.el-button--primary{
            border-color: #fff;
            background-color: #f3f3f3;
            color:#999;
        }
    }
    .bottom{
        margin-top: 30px;
        .answer{
            background-color: #f5f7f8;
            line-height: 36px;
            font-size: 14px;
            padding: 0 20px;
        }
        .analysis{
            display: flex;
            margin-top: 20px;                            
            background-color: #f5f7f8;
            line-height: 36px;
            font-size: 14px;
            padding: 0 20px;
            .title{
                color: #6B828C;
                display: flex;
                align-items: center;
            }
            .title::before{
                content: '';
                margin-right: 5px;
                display: inline-block;
                width: 5px;
                height: 22px;
                background-color: rgba(188, 208, 217, 1);
            }
        }
    }
}
.other-input{
    width: 80px;
    margin-left: 10px;
    
}
.other-input /deep/.el-input--mini .el-input__inner{
  height: 22px;
  line-height: 22px;
}
input:disabled {
    background: rgba(240, 240, 240, 0);
}
.StarsWrap {
  display: flex;
  justify-content: space-between;
  list-style: none;
  margin-top: 10px;
  min-width: 200px;
  max-width: 450px;
  padding-bottom: 5px;
  .StarsWrap-item{
    cursor: pointer;
  }
  
}

.amap-demo{
    width: 100%;
    height: 300px;
}
table, table td, table th {
    border: 1px solid #ccc;
    border-collapse: collapse;
    text-align: center;
    padding: 10px;
    font-size: 14px;
}

.ul_rate {
  display: flex;
  justify-content: space-around;
}



.option-box{
    display: flex;
    flex-wrap: wrap;
    // padding-left: 25px;
    box-sizing: border-box;
    .option{
        align-items: center;
        margin-top: 10px;
        display: flex;
        .other-input{
            width: 80px;
            margin-left: 10px;
        }
        /deep/.el-checkbox__label{
            display: flex;
            align-items: center;
            white-space: normal;
            word-break: break-all;
        }
        /deep/.el-checkbox__input{
            display: inline-block;
            margin-top:3px;
        }
        .other-input /deep/.el-input--mini .el-input__inner{
            height: 22px;
            line-height: 22px;
        }
    }
    /deep/.el-radio{
        margin-right: 0;
    }
    /deep/.el-checkbox{
        margin-right: 0;
    }
}
/deep/.el-checkbox__label,
/deep/.el-radio__label{
    display: flex;
    align-items: center;
    white-space: normal;
    word-break: break-all;
    font-size: inherit;
    text-decoration: inherit;
}

.el-slider-box{
    margin-left: 50px;
    display: flex;
    align-items: center;
    .el-slider{
        width: 400px;
    }
    .num{
        margin-left: 10px;
    }
}
.Rectinput {
	width: 120px;
	// height: 20px;
	border: 1px solid #ccc;
}
.matrix{
    /deep/.el-radio,
    /deep/.el-checkbox {
        padding: 10px;
        width: 100%;
        box-sizing: border-box;
        .el-radio__label,
        .el-checkbox__label {
            display: none;
        }
    }
}
</style>